import type { Location } from 'react-router-dom';
import { createAction } from 'typesafe-actions';

/**
 * We used to use react-connected-router when we were using react-router-dom (Version 5)
 * This is the action that was used to change the location in the router, and for now we
 * are keeping it around in order to not have to touch some of the redux actions themselves
 */
export const locationChange = createAction(
    'legacyConnectedRouter/LOCATION_CHANGE',
    (wrapPayload) => (payload: { location: Location<null> }) => wrapPayload(payload),
);
